const stTrack = (name = '', category = 'wc2026-schedule', action = 'click') => {
  window.parent.dataLayer = window.dataLayer || [];
  window.parent.dataLayer.push({
    event: 'graphics_event', //DO NOT CHANGE
    eventCategory: `graphics-${category.replaceAll(' ', '-')}`, //prepend with graphics-
    eventAction: action.replaceAll(' ', '-'), //select-dropdown
    eventLabel: name.replaceAll(' ', '-'), //fill-in any label
  });
};

export default stTrack;
